module.exports = __webpack_public_path__ + "img/rutherfordhall-h-474x356.d8fcf34f.jpg";